var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 19.38,
    stroke: "#F08300",
    strokeWidth: 1.76,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 15.351,
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.106383,11.0212766 C19.6586677,11.0212766 20.106383,11.4689918 20.106383,12.0212766 L20.1062766,18.1062766 L26.0212766,18.106383 C26.5735613,18.106383 27.0212766,18.5540982 27.0212766,19.106383 C27.0212766,19.6586677 26.5735613,20.106383 26.0212766,20.106383 L20.1062766,20.1062766 L20.106383,26.0212766 C20.106383,26.5735613 19.6586677,27.0212766 19.106383,27.0212766 C18.5540982,27.0212766 18.106383,26.5735613 18.106383,26.0212766 L18.1062766,20.1062766 L12.0212766,20.106383 C11.4689918,20.106383 11.0212766,19.6586677 11.0212766,19.106383 C11.0212766,18.5540982 11.4689918,18.106383 12.0212766,18.106383 L18.1062766,18.1062766 L18.106383,12.0212766 C18.106383,11.4689918 18.5540982,11.0212766 19.106383,11.0212766 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.1c18cbe2.svg";
export { ForwardRef as ReactComponent };